import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MonitorIcon, PaletteIcon, BookOpenIcon, BotIcon } from 'lucide-react';
const items = [{
  icon: MonitorIcon,
  title: 'Página de ventas profesional',
  description: 'Crea tu página con IA en minutos sin saber de tecnología'
}, {
  icon: PaletteIcon,
  title: 'Creativos que convierten',
  description: 'Imágenes y videos que detienen el scroll y generan ventas'
}, {
  icon: BookOpenIcon,
  title: 'Tu ebook irresistible',
  description: 'Estructura y diseño paso a paso con plantillas'
}, {
  icon: BotIcon,
  title: 'Prompts de IA exclusivos',
  description: 'Los prompts exactos para crear todo en minutos'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhatYouLearn() {
  return <section className="w-full bg-navy px-4 py-16 md:py-24" data-id="element-83">
      <div className="max-w-4xl mx-auto" data-id="element-84">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-oswald text-3xl md:text-4xl font-bold text-white text-center uppercase mb-12" data-id="element-85">
          En esta clase gratuita <span className="text-red" data-id="element-86">aprenderás:</span>
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-87">
          {items.map(item => <motion.div key={item.title} variants={cardVariants} className="bg-navy-card border border-navy-border rounded-xl p-6 md:p-8" data-id="element-88">
              <item.icon className="w-10 h-10 text-red mb-4" data-id="element-89" />
              <h3 className="font-oswald text-xl font-bold text-white uppercase mb-2" data-id="element-90">
                {item.title}
              </h3>
              <p className="text-gray font-inter text-sm leading-relaxed" data-id="element-91">
                {item.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}